import { applicationApiExecute } from './applicationActions';
import LessonProgress from '../api/lessonProgress';

export const completePart = applicationApiExecute(LessonProgress.completePart);
export const startLessonProgress = applicationApiExecute(LessonProgress.start);
export const completeLessonProgress = applicationApiExecute(LessonProgress.complete);
